import layoutEngine from "../../libraries/layoutEngine";

export function normalizePatternKey(patternName = "") {
  return String(patternName)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function generateNextPCellName(patternName) {
  const baseKey = normalizePatternKey(patternName);
  const allCellNames = layoutEngine.getAllCellNames?.() || [];

  const regex = new RegExp(`^${baseKey}_(\\d+)$`);
  let maxIndex = 0;

  for (const name of allCellNames) {
    const match = String(name).match(regex);
    if (!match) continue;
    const n = Number(match[1]);
    if (Number.isFinite(n)) {
      maxIndex = Math.max(maxIndex, n);
    }
  }

  return `${baseKey}_${maxIndex + 1}`;
}